import { FirebaseConfig } from './remote-config'

export default function isInteractiveAdEventBlacklisted(firebaseConfig: FirebaseConfig, athlinksEventId: number) {
  const raw = firebaseConfig.config.useInteractiveAdsEventBlacklist?.asString() ?? ''
  const blacklistedEvents = raw.split(',').map(x => +x).filter(y => !!y)

  return blacklistedEvents.includes(athlinksEventId)
}